import { render, staticRenderFns } from "./StockDaysBarChart.vue?vue&type=template&id=753b1494"
import script from "./StockDaysBarChart.vue?vue&type=script&lang=js"
export * from "./StockDaysBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('753b1494')) {
      api.createRecord('753b1494', component.options)
    } else {
      api.reload('753b1494', component.options)
    }
    module.hot.accept("./StockDaysBarChart.vue?vue&type=template&id=753b1494", function () {
      api.rerender('753b1494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/StockDaysBarChart.vue"
export default component.exports